<template>
  <div>
    <div class="m-upload-img">
      <input type="file"
             accept="image/*"
             @change="upload"
             ref="inputDom"
      >
      <p> Upload Photo</p>
      <img :src="img" class="user xx-large">
      <!--<b-img :src="imgSrc" rounded="circle"  fluid></b-img>-->
    </div>
  </div>
</template>

<script>
    export default {
      props: ['imgSrc'],
      data: function () {
        return {
          file: null,
          states: this.$store.state.user,
          img: null
        }
      },
      created () {
        this.img = this.imgSrc
      },
      watch: {
        imgSrc (val) {
          this.img = val
        }
      },
      methods: {
        upload: function () {
          var that = this
          var inputDom = this.$refs.inputDom
          this.file = inputDom.files[0]
          var reader = new FileReader()

          if (this.file.size > 2097152) {
            // toast({'title': 'UpLoad avatar Failed',
            //   'msg': 'The maximum size of the picture is 2M'})
            return false
          }

          reader.readAsDataURL(this.file)
          reader.onloadend = function () {
            that.img = this.result
            that.uploadSubmti(that.img)
            that.$store.commit('site/saveKey', ['UserImg', that.img])
          }
        },
        uploadSubmti: function (img) {
          this.$http.post('landingPage.aspx/UploadImg', {
            img: img,
            userId: this.states.userInfo.Userid
          }).then(resp => {
            if (resp.body.d.ResultFlag) {
              // toast({'title': 'Save Profile Settings Successed',
              //   'type': 'success'})
            } else {
              // toast({'title': 'Save Profile Settings Failed',
              //   'msg': 'Please try again, or cantact us'})
            }
          })
        }
      }
    }
</script>

<style scoped lang="scss">

  .m-upload-img{
    position: relative;
  }

  .m-upload-img p{
    position: absolute;
    color: #fff;
    left: 50%;
    top: 70px;
    margin-left: -50px;
    cursor: pointer;
  }

  .m-upload-img input{
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: pointer
  }
  .user {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    object-fit: cover;
    vertical-align: middle;
    margin-right: 10px;
  }
  .user.x-large {
    width: 55px;
    height: 55px;
    border: 1px solid $color-primary;
  }
  .user.xx-large {
    width: 120px;
    height: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/components/landings/MUploadImg.vue